import { handleOriginSource } from './preproccess/handle-origin-source'
import { handleNewsSource } from './preproccess/handle-news-source'
import { handleOriginalNews } from './preproccess/handle-original-news'
import { handleEmoji } from './preproccess/handle-emoji'
import { handleShareInfo } from './preproccess/handle-share-info'
import { handleSpecialHtml } from './preproccess/handle-special-html'
const TEXT_ELEMENT_TAG = ['BR', 'A', 'B', 'SPAN']
const CONTAINER_ELEMENT_TAG = ['UL', 'OL', 'LI', 'BLOCKQUOTE', 'DIV']

export function traverseArticle (data, is_container = false) {
  const container = document.createElement('div')
  container.innerHTML = data
  !is_container && preHandleContent.call(this, container)
  const dom_stack = [...container.childNodes].reverse()
  const content = []
  while (dom_stack.length != 0) {
    let cur = dom_stack.pop()
    if (isContainerElement(cur)) {
      let inner = handleContainerCpt.call(this, cur)
      if (inner instanceof Array) {
        content.push(...inner)
      } else {
        content.push(inner)
      }
    } else if (isImgELement(cur)) {
      let card = this.handleCustomeCard(cur)
      if (card.cpt) {
        content.push(card)
      } else {
        content.push(handleBaseCpt.call(this, cur))
      }
    } else if (!hasElementNodeInside(cur)) {
      content.push(handleBaseCpt.call(this, cur))
    } else {
      dom_stack.push(...Array.from(cur.childNodes).reverse())
    }
  }
  return content
}


function handleContainerCpt (node) {
  let temp 
  switch (node.tagName) {
    case 'BLOCKQUOTE': {
      temp = window.hb__format['blockquote'].call(this, node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    case 'LI': {
      temp = window.hb__format['line'].call(this, node)
      if (!hasElementNodeInside(node)) {
        temp.data.children = node.innerHTML
      } else {
        temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      }
      break
    }
    case 'UL': {
      temp = window.hb__format['unorder_list'].call(this, node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    case 'OL': {
      temp = window.hb__format['order_list'].call(this, node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    default: {
      temp = traverseArticle.call(this, node.innerHTML, true)
    }
  }
  return temp
}

function handleBaseCpt (node) {
  switch (node.tagName) {
    case 'H1': {
      console.log('[h1]: ', node);
      return window.hb__format['main_title'].call(this, node)
      break
    }
    case 'H2': {
      console.log('[h2]: ', node);
      return window.hb__format['main_title'].call(this, node)
      break
    }
    case 'H3': {
      console.log('[h3]: ', node);
      return window.hb__format['sub_title'].call(this, node)
      break
    }
    case 'H4': {
      console.log('[h4]: ', node);
      return window.hb__format['img_desc'].call(this, node)
      break
    }
    case 'IMG': {
      console.log('[img]: ', node);
      return window.hb__format['img'].call(this, node)
      break
    }
    case 'IFRAME': {
      console.log('[iframe]: ', node);
      return window.hb__format['iframe'].call(this, node)
      break
    }
    case 'P': {
      console.log('[text]: ', node);
      return window.hb__format['text'].call(this, node)
      break
    }
    case 'ORIGIN-SOURCE': {
      console.log('[origin-source]: ', node);
      return window.hb__format['origin_source'].call(this, node)
      break
    }
    case 'NEWS-SOURCE': {
      console.log('[news-source]: ', node);
      return window.hb__format['news_source'].call(this, node)
      break
    }
    default: {
      console.log('[other]: ', node);
      return window.hb__format['text'].call(this, node)
    }
  }
}

// 预处理
function preHandleContent (container) {
  handleEmoji(container, this.origin_data)
  handleNewsSource(container, this.origin_data)
  handleOriginSource(container, this.origin_data)
  handleOriginalNews(container, this.origin_data)
  handleShareInfo.call(this, container, this.origin_data)
  handleSpecialHtml.call(this, container, this.origin_data)
}

function isImgELement (node) {
  if (node.nodeType != 1) return false
  return node.tagName == 'IMG'
}

function isContainerElement (node) {
  if (node.nodeType != 1) return false
  return CONTAINER_ELEMENT_TAG.includes(node.tagName)
}

function hasElementNodeInside (node) {
  if (node.nodeType != 1) return false
  
  return Array.from(node.childNodes).find(_=>_.nodeType == 1 && !TEXT_ELEMENT_TAG.includes(_.tagName))
}